// extracted by mini-css-extract-plugin
export default {"descricao":"EsqueceuSenha_descricao__8qEN6","botoes":"EsqueceuSenha_botoes__Fcj8q"};